interface ChevronDownProps extends React.SVGProps<SVGSVGElement> {}
const ChevronDown = (props: ChevronDownProps) => {
  return (
    <svg
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Chevron Down</title>
      <path
        d="M4 7L8 11L12 7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

export default ChevronDown;
